import React from "react";
import * as palette from "@govlaunch/palette";
import { FormattedMessage, useIntl } from "react-intl";

export default function ShowMoreButton({ ...props }: React.HTMLAttributes<HTMLDivElement>) {
  const intl = useIntl();

  return (
    <div
      role="button"
      aria-label={intl.formatMessage({
        defaultMessage: "Show more",
        id: "aWpBzj",
      })}
      css={{
        cursor: "pointer",
        minHeight: 40,
        textTransform: "uppercase",
        color: palette.sealBlue,
        fontSize: 12,
        textAlign: "center",
        "&:hover": {
          color: palette.darkGray,
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...props}
    >
      <FormattedMessage defaultMessage="Show more" id="aWpBzj" />
    </div>
  );
}
